import React from 'react';
import dsi18n from '@/i18n/ds';
import { parseImage } from '@/utils/media-transfer';
import { DotElement, dotSceneNameMap } from '@/components/dots';
import { articleDetailType } from '../typing';
import './index.less';

const getShareUrl = (url: string, title: string) => {
  return [
    `https://www.facebook.com/sharer.php?u=${encodeURIComponent(url)}&p[title]=${title}`,
    `http://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
      url,
    )}&content=utf-8&source=${encodeURIComponent(url)}`,
    `https://twitter.com/intent/tweet?original_referer=${encodeURIComponent(
      url,
    )}&text=${title}&url=${encodeURIComponent(url)}`,
  ];
};

function Share(props: { article: articleDetailType }) {
  const { article } = props;
  const [facebookShareUrl, linkedinShareUrl, twitterShareUrl] = getShareUrl(
    location.href,
    article.name,
  );
  const baseDotParams = {
    scene: dotSceneNameMap.blogDetail.detail,
    action: 'share_click',
    channelName: window.__channelName,
  };
  return (
    <div className="list-share">
      <div className="share-text">{dsi18n('article.ShareButton')}</div>
      <div className="share-icon">
        <DotElement
          elementTag="a"
          target="_blank"
          href={twitterShareUrl}
          dotType="clk"
          dotParams={{
            ...baseDotParams,
            type: 'twitter',
          }}>
          <img
            src={parseImage({
              img: 'https://img.alicdn.com/imgextra/i2/O1CN01SHAwB81qLQkMEKDT1_!!6000000005479-2-tps-120-120.png',
            })}
            alt="twitter"
          />
        </DotElement>
        <DotElement
          elementTag="a"
          target="_blank"
          href={facebookShareUrl}
          dotType="clk"
          dotParams={{
            ...baseDotParams,
            type: 'facebook',
          }}>
          <img
            src={parseImage({
              img: 'https://img.alicdn.com/imgextra/i3/O1CN01PWSkaa1ljBCiYgbmH_!!6000000004854-2-tps-120-120.png',
            })}
            alt="facebook"
          />
        </DotElement>
        <DotElement
          elementTag="a"
          target="_blank"
          href={linkedinShareUrl}
          dotType="clk"
          dotParams={{
            ...baseDotParams,
            type: 'linkedin',
          }}>
          <img
            src={parseImage({
              img: 'https://img.alicdn.com/imgextra/i4/O1CN01ccKHiT1owrtOe6ASB_!!6000000005290-2-tps-120-120.png',
            })}
            alt="linkedin"
          />
        </DotElement>
      </div>
    </div>
  );
}

export default Share;
